import React, { useEffect } from 'react';

import { Switch, Route, Redirect, useParams, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import VerticalLayout from './layout/vertical/Vertical';
import HorizontalLayout from './layout/horizontal/Horizontal';

import NotFound from './pages/sessions/404';
import { defaultRoutes, sessionRoutes } from './routing';

import './App.scss';
import { useHideLoader } from './hooks/useHideLoader';

import { setPageData, updatePageDada } from './redux/page-data/actions';

import { history } from './redux/store';

const Routes = ({ routes, layout = '' }) => (
  <Switch>
    {routes.map((route, index) => (
      <Route
        key={index}
        exact={route.exact}
        path={layout.length > 0 ? `/${layout}/${route.path}` : `/${route.path}`}
        component={route.component}
      />
    ))}

     <Route path='*'>
      <Redirect to='/public/page-404' />
    </Route> 
  </Switch>
);

const DefaultRoutes = ({ layout }) => <Routes routes={defaultRoutes} layout={layout} />;

const SessionRoutes = () => <Routes routes={sessionRoutes} layout='public' />;

const App = () => {

  const location = useLocation();
  console.log(location.pathname);
  console.log(location.pathname.toLowerCase().includes('testdetails'))

  const dispatch = useDispatch();
  const vacc_id = useParams();

useEffect(() => {
  const employeeInfo = JSON.parse(localStorage.getItem('employeeInfo'));
  const path = location.pathname.toLowerCase();

  const isPublicRoute =
    path.startsWith('/public') ||        // 👈 allow all auth pages
    path.includes('vaccinationdetails') ||
    path.includes('physicalform') ||
    path.includes('intakeform') ||
    path.includes('testdetails');

  if (employeeInfo || isPublicRoute) {
    dispatch(updatePageDada({ fulFilled: true, loaded: true }));
  } else {
    history.replace('/public/sign-in/');
  }
}, [location.pathname]);


  useHideLoader();

  return (
    <Switch>
      <Route path='/' exact>
        <Redirect to='/public/sign-in/' />
      </Route>
      <Route path='/default-dashboard' exact>
        <Redirect to='/vertical/default-dashboard' />
      </Route>

      <Route path='/public'>
        <SessionRoutes />
      </Route>

      <Route path='/horizontal'>
        <HorizontalLayout>
          <DefaultRoutes layout='horizontal' />
        </HorizontalLayout>
      </Route>

      <Route path='/vertical'>
        <VerticalLayout>
          <DefaultRoutes layout='vertical' />
        </VerticalLayout>
      </Route>

      <Route path='*'>
        <NotFound />
      </Route>
    </Switch>
  );
};

export default App;
